import PropTypes from 'prop-types'
import ORIGIN from 'Common/constants/search'
import SortBy from '../extensions/SortBy'
import {
  materials,
  materialsAlphabetical,
  materialsRecent,
  materialsRanking,
} from '../../constants/indices'

// Search page
const sortItems = [
  {
    label: 'Relevance',
    value: materials,
  },
  {
    label: 'Alphabetical',
    value: materialsAlphabetical,
  },
  {
    label: 'Last Updated',
    value: materialsRecent,
  },
]

// Collections page
const sortItemsCollections = [
  {
    label: 'Relevance',
    value: materialsRanking,
  },
  {
    label: 'Alphabetical',
    value: materialsAlphabetical,
  },
  {
    label: 'Last Updated',
    value: materialsRecent,
  },
]

export default function Sort({ origin }) {
  return (
    <SortBy
      items={origin === ORIGIN.collections ? sortItemsCollections : sortItems}
      defaultRefinement={
        origin === ORIGIN.collections ? materialsRanking : materials
      }
    />
  )
}

Sort.defaultProps = {
  origin: null,
}

Sort.propTypes = {
  origin: PropTypes.string,
}
